<h6 class="font-semibold">{{'#TICKETS/PUBLIC.TICKET_ACCOUNT_CONTEXT' | translate}}</h6>
@if (availableAccounts$ | async; as availableAccounts) {
  @if (accountIds$ | async; as accountIds) {
    @if (accountId$ | async; as accountId) {
      <soft-chip-group>
        @for (account of availableAccounts; track account) {
          <soft-chip class="mr-2 mt-2 select-none"
                   [ngClass]="{
                      'bg-primary text-primary-contrast': (account.id | in:accountIds) && account.id !== accountId,
                      'font-bold underline bg-accent text-accent-contrast': account.id === accountId,
                      'cursor-pointer': account.id !== accountId
                   }"
            (click)="toggleAccount(account.id)"
          >{{account.name}}</soft-chip>
        }
      </soft-chip-group>
    }
  }
  <div class="flex flex-row justify-end my-3">
    <a class="soft-link mr-3" (click)="selectAll()">{{'#TICKETS/PUBLIC.SELECT_ALL' | translate}}</a>
    /
    <a class="soft-link ml-3" (click)="selectNone()">{{'#TICKETS/PUBLIC.SELECT_NONE' | translate}}</a>
  </div>
}
